import React from "react"
import classnames from "classnames"
import { Input } from "AtomicComponents"
import styles from "./InputEmail.less"

class InputEmail extends React.PureComponent {

  _onBlurHandler = () => {
    const { onBlur = () => { } } = this.props
    onBlur()
  }

  _onChangeHandler = (value) => {
    const { onChange = () => { } } = this.props
    onChange(value)
  }

  _getThisInput = (inputThis) => {
    const { getThisInput = () => { } } = this.props
    getThisInput(inputThis)
  }


  render() {
    const {
      label,
      name,
      required,
      isValid,
      message,
      defaultValue
    } = this.props
    return (
      <Input
        label={label}
        getThisInput={this._getThisInput}
        name={name}
        type='email'
        required={required}
        defaultValue={defaultValue}
        isValid={isValid}
        message={message}
        onChange={this._onChangeHandler}
        onBlur={this._onBlurHandler}
      />
    )
  }
}


export default InputEmail



// WEBPACK FOOTER //
// ./src/AtomicComponents/InputEmail/InputEmail.jsx